import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { thinkingLevelsFor } from '../../utils/vinExtraction';

/** Shown only for a selected model that takes a thinking level; another model keeps the stored level unsent. */
const ThinkingLevelField = ({ settings }) => {
    const { t } = useTranslation('vinExtraction');
    const model = Form.useWatch('model', Form.useFormInstance());
    const levels = thinkingLevelsFor(settings, model);
    if (levels.length === 0) return null;

    return (
        <Form.Item name="thinkingLevel" label={t('edit.thinkingLevel')} extra={t('edit.thinkingLevelHelp')}>
            <Select options={levels.map(level => ({ value: level, label: t(`edit.thinkingLevels.${level}`) }))} />
        </Form.Item>
    );
};

export default ThinkingLevelField;
